import React from "react";
import PropTypes from 'prop-types';


export default function Feedback({icon, children}) {
  return (
    <li>
      <i className={`fa ${icon} fa-fw`}/>
      <div className="info_text">
        {children}
      </div>
    </li>
  );
}

Feedback.propTypes = {
  icon: PropTypes.string.isRequired
};
